import axios from "axios";
import { toast } from "react-toastify";
import {
  LAYER_TEMPLATE_FETCH_REQUEST,
  LAYER_TEMPLATE_FETCH_SUCCESS,
  LAYER_TEMPLATE_FETCH_FAILURE,
  LAYER_TEMPLATE_CREATE_SUCCESS,
  LAYER_TEMPLATE_UPDATE_SUCCESS,
  LAYER_TEMPLATE_DELETE_SUCCESS,
} from "../types/layerTemplateTypes";

// ── Fetch all active templates ────────────────────────────────────────
export const fetchLayerTemplates = () => async (dispatch) => {
    dispatch({ type: LAYER_TEMPLATE_FETCH_REQUEST });
    try {
      const params = { is_active: true };
      const { data } = await axios.get("config/layer-templates", { params });
      dispatch({ type: LAYER_TEMPLATE_FETCH_SUCCESS, payload: data });
      return data;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      dispatch({ type: LAYER_TEMPLATE_FETCH_FAILURE, payload: msg });
    }
  };

// ── Fetch all (admin – includes inactive) ────────────────────────────
export const fetchAllLayerTemplates = () => async (dispatch) => {
  dispatch({ type: LAYER_TEMPLATE_FETCH_REQUEST });
  try {
    const { data } = await axios.get("config/layer-templates");
    dispatch({ type: LAYER_TEMPLATE_FETCH_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const msg = error.response?.data?.message || error.message;
    dispatch({ type: LAYER_TEMPLATE_FETCH_FAILURE, payload: msg });
  }
};

// ── Create ───────────────────────────────────────────────────────────
export const createLayerTemplate = (templateData) => async (dispatch) => {
  try {
    const { data } = await axios.post("config/layer-templates", templateData);
    dispatch({ type: LAYER_TEMPLATE_CREATE_SUCCESS, payload: data });
    toast.success("Layer template saved");
    return data;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to save template");
    throw error;
  }
};

// ── Update ───────────────────────────────────────────────────────────
export const updateLayerTemplate = (id, templateData) => async (dispatch) => {
  try {
    const { data } = await axios.put(`config/layer-templates/${id}`, templateData);
    dispatch({ type: LAYER_TEMPLATE_UPDATE_SUCCESS, payload: data });
    toast.success("Layer template updated");
    return data;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to update template");
    throw error;
  }
};

// ── Delete ───────────────────────────────────────────────────────────
export const deleteLayerTemplate = (id) => async (dispatch) => {
  try {
    await axios.delete(`config/layer-templates/${id}`);
    dispatch({ type: LAYER_TEMPLATE_DELETE_SUCCESS, payload: id });
    toast.success("Layer template deleted");
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to delete template");
    throw error;
  }
};
